import { render, staticRenderFns } from "./Datenschutz.vue?vue&type=template&id=58d8f436&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Datenschutz.vue"
export default component.exports